import { Typography } from '@jouzen/ecom-components/v3/Typography';
import type { ReactNode } from 'react';

interface Props {
  readonly className?: string;
  readonly children: ReactNode;
  readonly small?: boolean;
}

const Subtitle = ({ className, children, small, ...props }: Props) => (
  <Typography
    data-cy="lp-subtitle"
    Element="p"
    variant={small ? 'h6' : 'h4'}
    color="inherit"
    className={className!}
    {...props}
  >
    {children}
  </Typography>
);

export default Subtitle;
